import {equalsFlag, hasFlag, MatchMessageFlags, noFlag} from '@/domain/models';

type MediaMessageVisibility = {
  flags: number;
  sender_user_id: number;
};

const FLAGS_NOT_SAFE =
  MatchMessageFlags.FLAG_SENSITIVE | MatchMessageFlags.FLAG_SUSPICIOUS;
const FLAGS_SENSITIVE_AND_REVEALED =
  MatchMessageFlags.FLAG_SENSITIVE | MatchMessageFlags.FLAG_SENSITIVE_REVEALED;
const FLAGS_SUSPICIOUS_AND_REVEALED =
  MatchMessageFlags.FLAG_SUSPICIOUS |
  MatchMessageFlags.FLAG_SUSPICIOUS_REVEALED;

export function isVisibleMediaMessage(
  message: MediaMessageVisibility,
  otherUserId: number | undefined
): boolean {
  if (!hasFlag(message.flags, MatchMessageFlags.FLAG_HAS_MEDIA)) {
    return false;
  }

  if (otherUserId === undefined || message.sender_user_id !== otherUserId) {
    return true;
  }

  return (
    noFlag(message.flags, FLAGS_NOT_SAFE) ||
    equalsFlag(message.flags, FLAGS_SENSITIVE_AND_REVEALED) ||
    equalsFlag(message.flags, FLAGS_SUSPICIOUS_AND_REVEALED)
  );
}
